import { SnackbarProgrammatic as Snackbar } from 'buefy';

export default {
  success(msg = '') {
    Snackbar.open({
      message: msg,
      duration: 5000,
      position: 'is-bottom-left',
      type: 'is-success',
      queue: false,
    });
  },
  warning(msg = '') {
    Snackbar.open({
      message: msg,
      type: 'is-warning',
      duration: 10000,
      position: 'is-bottom-left',
    });
  },
  error(msg = '') {
    Snackbar.open({
      message: msg,
      duration: 10000,
      position: 'is-bottom-left',
      type: 'is-danger',
    });
  },
  serverError() {
    Snackbar.open({
      message: '',
      duration: 10000,
      position: 'is-bottom-left',
    });
  },
};
